const languagesArr = [
  { code: 'ab', language: 'Abkhazian' },
  { code: 'aa', language: 'Afar' },
  { code: 'af', language: 'Afrikaans' },
  { code: 'ak', language: 'Akan' },
  { code: 'sq', language: 'Albanian' },
  { code: 'am', language: 'Amharic' },
  { code: 'ar', language: 'Arabic' },
  { code: 'an', language: 'Aragonese' },
  { code: 'hy', language: 'Armenian' },
  { code: 'as', language: 'Assamese' },
  { code: 'av', language: 'Avaric' },
  { code: 'ae', language: 'Avestan' },
  { code: 'ay', language: 'Aymara' },
  { code: 'az', language: 'Azerbaijani' },
  { code: 'bm', language: 'Bambara' },
  { code: 'ba', language: 'Bashkir' },
  { code: 'eu', language: 'Basque' },
  { code: 'be', language: 'Belarusian' },
  { code: 'bn', language: 'Bengali' },
  { code: 'bh', language: 'Bihari' },
  { code: 'bi', language: 'Bislama' },
  { code: 'bs', language: 'Bosnian' },
  { code: 'br', language: 'Breton' },
  { code: 'bg', language: 'Bulgarian' },
  { code: 'my', language: 'Burmese' },
  { code: 'ca', language: 'Catalan, Valencian' },
  { code: 'ch', language: 'Chamorro' },
  { code: 'ce', language: 'Chechen' },
  { code: 'ny', language: 'Chichewa, Chewa, Nyanja' },
  // { code: 'zh', language: 'Chinese' },
  { code: 'cv', language: 'Chuvash' },
  { code: 'kw', language: 'Cornish' },
  { code: 'co', language: 'Corsican' },
  { code: 'cr', language: 'Cree' },
  { code: 'hr', language: 'Croatian' },
  { code: 'cs', language: 'Czech' },
  { code: 'da', language: 'Danish' },
  { code: 'dv', language: 'Divehi, Dhivehi, Maldivian' },
  { code: 'nl', language: 'Dutch, Flemish' },
  { code: 'dz', language: 'Dzongkha' },
  // { code: 'en', language: 'English' },
  { code: 'eo', language: 'Esperanto' },
  { code: 'et', language: 'Estonian' },
  { code: 'ee', language: 'Ewe' },
  { code: 'fo', language: 'Faroese' },
  { code: 'fj', language: 'Fijian' },
  { code: 'fi', language: 'Finnish' },
  { code: 'fr', language: 'French' },
  { code: 'ff', language: 'Fulah' },
  { code: 'gl', language: 'Galician' },
  { code: 'ka', language: 'Georgian' },
  { code: 'de', language: 'German' },
  { code: 'el', language: 'Greek' },
  { code: 'gn', language: 'Guarani' },
  { code: 'gu', language: 'Gujarati' },
  { code: 'ht', language: 'Haitian, Haitian Creole' },
  { code: 'ha', language: 'Hausa' },
  { code: 'he', language: 'Hebrew' },
  { code: 'hz', language: 'Herero' },
  { code: 'hi', language: 'Hindi' },
  { code: 'ho', language: 'Hiri Motu' },
  { code: 'hu', language: 'Hungarian' },
  { code: 'ia', language: 'Interlingua' },
  { code: 'id', language: 'Indonesian' },
  { code: 'ie', language: 'Interlingue, Occidental' },
  { code: 'ga', language: 'Irish' },
  { code: 'ig', language: 'Igbo' },
  { code: 'ik', language: 'Inupiaq' },
  { code: 'io', language: 'Ido' },
  { code: 'is', language: 'Icelandic' },
  { code: 'it', language: 'Italian' },
  { code: 'iu', language: 'Inuktitut' },
  { code: 'ja', language: 'Japanese' },
  { code: 'jv', language: 'Javanese' },
  { code: 'kl', language: 'Kalaallisut, Greenlandic' },
  { code: 'kn', language: 'Kannada' },
  { code: 'kr', language: 'Kanuri' },
  { code: 'ks', language: 'Kashmiri' },
  { code: 'kk', language: 'Kazakh' },
  { code: 'km', language: 'Central Khmer' },
  { code: 'ki', language: 'Kikuyu, Gikuyu' },
  { code: 'rw', language: 'Kinyarwanda' },
  { code: 'ky', language: 'Kirghiz, Kyrgyz' },
  { code: 'kv', language: 'Komi' },
  { code: 'kg', language: 'Kongo' },
  { code: 'ko', language: 'Korean' },
  { code: 'ku', language: 'Kurdish' },
  { code: 'kj', language: 'Kuanyama, Kwanyama' },
  { code: 'la', language: 'Latin' },
  { code: 'lb', language: 'Luxembourgish, Letzeburgesch' },
  { code: 'lg', language: 'Ganda' },
  { code: 'li', language: 'Limburgan, Limburger, Limburgish' },
  { code: 'ln', language: 'Lingala' },
  { code: 'lo', language: 'Lao' },
  { code: 'lt', language: 'Lithuanian' },
  { code: 'lu', language: 'Luba-Katanga' },
  { code: 'lv', language: 'Latvian' },
  { code: 'gv', language: 'Manx' },
  { code: 'mk', language: 'Macedonian' },
  { code: 'mg', language: 'Malagasy' },
  { code: 'ms', language: 'Malay' },
  { code: 'ml', language: 'Malayalam' },
  { code: 'mt', language: 'Maltese' },
  { code: 'mi', language: 'Maori' },
  { code: 'mr', language: 'Marathi' },
  { code: 'mh', language: 'Marshallese' },
  { code: 'mn', language: 'Mongolian' },
  { code: 'na', language: 'Nauru' },
  { code: 'nv', language: 'Navajo, Navaho' },
  { code: 'nd', language: 'North Ndebele' },
  { code: 'ne', language: 'Nepali' },
  { code: 'ng', language: 'Ndonga' },
  { code: 'nb', language: 'Norwegian Bokmål' },
  { code: 'nn', language: 'Norwegian Nynorsk' },
  { code: 'no', language: 'Norwegian' },
  { code: 'ii', language: 'Sichuan Yi, Nuosu' },
  { code: 'nr', language: 'South Ndebele' },
  { code: 'oc', language: 'Occitan' },
  { code: 'oj', language: 'Ojibwa' },
  {
    code: 'cu',
    language:
      'Church Slavic, Old Slavonic, Church Slavonic, Old Bulgarian, Old Church Slavonic',
  },
  { code: 'om', language: 'Oromo' },
  { code: 'or', language: 'Oriya' },
  { code: 'os', language: 'Ossetian, Ossetic' },
  { code: 'pa', language: 'Punjabi, Panjabi' },
  { code: 'pi', language: 'Pali' },
  { code: 'fa', language: 'Persian' },
  { code: 'pl', language: 'Polish' },
  { code: 'ps', language: 'Pashto, Pushto' },
  { code: 'pt', language: 'Portuguese' },
  { code: 'qu', language: 'Quechua' },
  { code: 'rm', language: 'Romansh' },
  { code: 'rn', language: 'Rundi' },
  { code: 'ro', language: 'Romanian, Moldavian, Moldovan' },
  { code: 'ru', language: 'Russian' },
  { code: 'sa', language: 'Sanskrit' },
  { code: 'sc', language: 'Sardinian' },
  { code: 'sd', language: 'Sindhi' },
  { code: 'se', language: 'Northern Sami' },
  { code: 'sm', language: 'Samoan' },
  { code: 'sg', language: 'Sango' },
  { code: 'sr', language: 'Serbian' },
  { code: 'gd', language: 'Gaelic, Scottish Gaelic' },
  { code: 'sn', language: 'Shona' },
  { code: 'si', language: 'Sinhala, Sinhalese' },
  { code: 'sk', language: 'Slovak' },
  { code: 'sl', language: 'Slovenian' },
  { code: 'so', language: 'Somali' },
  { code: 'st', language: 'Southern Sotho' },
  { code: 'es', language: 'Spanish, Castilian' },
  { code: 'su', language: 'Sundanese' },
  { code: 'sw', language: 'Swahili' },
  { code: 'ss', language: 'Swati' },
  { code: 'sv', language: 'Swedish' },
  { code: 'ta', language: 'Tamil' },
  { code: 'te', language: 'Telugu' },
  { code: 'tg', language: 'Tajik' },
  { code: 'th', language: 'Thai' },
  { code: 'ti', language: 'Tigrinya' },
  { code: 'bo', language: 'Tibetan' },
  { code: 'tk', language: 'Turkmen' },
  { code: 'tl', language: 'Tagalog' },
  { code: 'tn', language: 'Tswana' },
  { code: 'to', language: 'Tonga' },
  { code: 'tr', language: 'Turkish' },
  { code: 'ts', language: 'Tsonga' },
  { code: 'tt', language: 'Tatar' },
  { code: 'tw', language: 'Twi' },
  { code: 'ty', language: 'Tahitian' },
  { code: 'ug', language: 'Uighur, Uyghur' },
  { code: 'uk', language: 'Ukrainian' },
  { code: 'ur', language: 'Urdu' },
  { code: 'uz', language: 'Uzbek' },
  { code: 've', language: 'Venda' },
  { code: 'vi', language: 'Vietnamese' },
  { code: 'vo', language: 'Volapük' },
  { code: 'wa', language: 'Walloon' },
  { code: 'cy', language: 'Welsh' },
  { code: 'wo', language: 'Wolof' },
  { code: 'fy', language: 'West Frisian' },
  { code: 'xh', language: 'Xhosa' },
  { code: 'yi', language: 'Yiddish' },
  { code: 'yo', language: 'Yoruba' },
  { code: 'za', language: 'Zhuang, Chuang' },
  { code: 'zu', language: 'Zulu' },
]

export default languagesArr
